// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.settings-menu_icon_F9o4f {
    filter: var(--icon-style);
    width: 1.5rem;
    -webkit-filter: var(--icon-style);
}

.settings-menu_theme-label_J7W4H {
    flex: 1;
}

.settings-menu_option_Bmq0t {
    display: flex;
    align-items: center;
    gap: .5rem;
}

.settings-menu_check_Mk9qT {
    filter: var(--icon-style);
    margin: 0 .25rem 0 0;
    visibility: hidden;
}

[dir="rtl"] .settings-menu_check_Mk9qT {
    margin: 0 0 0 .25rem;
}

.settings-menu_selected_JImeI {
    visibility: visible;
}

.settings-menu_submenu-label_WTCzu {
    flex: 1;
}

.settings-menu_dropdown-label_PnHC3 {
    margin: 0 0.5rem 0 0.25rem;
}

[dir="rtl"] .settings-menu_dropdown-label_PnHC3 {
    margin: 0 0.25rem 0 0.5rem;
}

.settings-menu_expand-caret_G5vQu {
    filter: var(--icon-style);
    transform: rotate(-90deg);
}

[dir="rtl"] .settings-menu_expand-caret_G5vQu {
    transform: rotate(90deg);
}

/* Extra padding to deal with scrollbar overlapping options in Firefox */

[dir="ltr"] .settings-menu_language-menu-item_RTmN5 {
    padding-right: 1rem;
}

[dir="rtl"] .settings-menu_language-menu-item_RTmN5 {
    padding-left: 1rem;
}

.settings-menu_language-submenu_GptV0 > ul {
    max-height: calc(100vh - 5rem); /* Fallback if dvh not supported */
    max-height: calc(100dvh - 5rem);
}

@media only screen and (max-width: 1124px) {
    .settings-menu_dropdown-label_PnHC3 {
        display: none;
    }
    .settings-menu_SettingIcon_lpA0q{
        width: 20px !important;
    }
}

.settings-menu_accent-icon-outer_yL_Wv {
    width: 24px;
    height: 24px;
    border: 3px solid var(--menu-bar-foreground);
    border-radius: 100%;
    box-sizing: border-box;
    transform-origin: center;
    transform: scale(90%);
}

.settings-menu_disabled_EL_fv {
    opacity: 0.5;
}

.settings-menu_disabled_EL_fv img {
    filter: grayscale(100%);
}

.settings-menu_open-link_DedrQ {
    filter: var(--icon-style);
    margin-left: 0.5rem;
}

.settings-menu_SettingIcon_lpA0q{
    filter: var(--icon-style);
    width: 20px;
    height: auto;
}

.settings-menu_dropdownCaret_zYOmM {
    filter: var(--icon-style);
}`, "",{"version":3,"sources":["webpack://./src/components/menu-bar/settings-menu.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,yBAAyB;IACzB,aAAa;IACb,iCAAiC;AACrC;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,wEAAwE;;AAExE;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,8BAA8B,EAAE,kCAAkC;IAClE,+BAA+B;AACnC;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,4CAA4C;IAC5C,mBAAmB;IACnB,sBAAsB;IACtB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.icon {\n    filter: var(--icon-style);\n    width: 1.5rem;\n    -webkit-filter: var(--icon-style);\n}\n\n.theme-label {\n    flex: 1;\n}\n\n.option {\n    display: flex;\n    align-items: center;\n    gap: .5rem;\n}\n\n.check {\n    filter: var(--icon-style);\n    margin: 0 .25rem 0 0;\n    visibility: hidden;\n}\n\n[dir=\"rtl\"] .check {\n    margin: 0 0 0 .25rem;\n}\n\n.selected {\n    visibility: visible;\n}\n\n.submenu-label {\n    flex: 1;\n}\n\n.dropdown-label {\n    margin: 0 0.5rem 0 0.25rem;\n}\n\n[dir=\"rtl\"] .dropdown-label {\n    margin: 0 0.25rem 0 0.5rem;\n}\n\n.expand-caret {\n    filter: var(--icon-style);\n    transform: rotate(-90deg);\n}\n\n[dir=\"rtl\"] .expand-caret {\n    transform: rotate(90deg);\n}\n\n/* Extra padding to deal with scrollbar overlapping options in Firefox */\n\n[dir=\"ltr\"] .language-menu-item {\n    padding-right: 1rem;\n}\n\n[dir=\"rtl\"] .language-menu-item {\n    padding-left: 1rem;\n}\n\n.language-submenu > ul {\n    max-height: calc(100vh - 5rem); /* Fallback if dvh not supported */\n    max-height: calc(100dvh - 5rem);\n}\n\n@media only screen and (max-width: 1124px) {\n    .dropdown-label {\n        display: none;\n    }\n    .SettingIcon{\n        width: 20px !important;\n    }\n}\n\n.accent-icon-outer {\n    width: 24px;\n    height: 24px;\n    border: 3px solid var(--menu-bar-foreground);\n    border-radius: 100%;\n    box-sizing: border-box;\n    transform-origin: center;\n    transform: scale(90%);\n}\n\n.disabled {\n    opacity: 0.5;\n}\n\n.disabled img {\n    filter: grayscale(100%);\n}\n\n.open-link {\n    filter: var(--icon-style);\n    margin-left: 0.5rem;\n}\n\n.SettingIcon{\n    filter: var(--icon-style);\n    width: 20px;\n    height: auto;\n}\n\n.dropdownCaret {\n    filter: var(--icon-style);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `settings-menu_icon_F9o4f`,
	"theme-label": `settings-menu_theme-label_J7W4H`,
	"themeLabel": `settings-menu_theme-label_J7W4H`,
	"option": `settings-menu_option_Bmq0t`,
	"check": `settings-menu_check_Mk9qT`,
	"selected": `settings-menu_selected_JImeI`,
	"submenu-label": `settings-menu_submenu-label_WTCzu`,
	"submenuLabel": `settings-menu_submenu-label_WTCzu`,
	"dropdown-label": `settings-menu_dropdown-label_PnHC3`,
	"dropdownLabel": `settings-menu_dropdown-label_PnHC3`,
	"expand-caret": `settings-menu_expand-caret_G5vQu`,
	"expandCaret": `settings-menu_expand-caret_G5vQu`,
	"language-menu-item": `settings-menu_language-menu-item_RTmN5`,
	"languageMenuItem": `settings-menu_language-menu-item_RTmN5`,
	"language-submenu": `settings-menu_language-submenu_GptV0`,
	"languageSubmenu": `settings-menu_language-submenu_GptV0`,
	"SettingIcon": `settings-menu_SettingIcon_lpA0q`,
	"settingIcon": `settings-menu_SettingIcon_lpA0q`,
	"accent-icon-outer": `settings-menu_accent-icon-outer_yL_Wv`,
	"accentIconOuter": `settings-menu_accent-icon-outer_yL_Wv`,
	"disabled": `settings-menu_disabled_EL_fv`,
	"open-link": `settings-menu_open-link_DedrQ`,
	"openLink": `settings-menu_open-link_DedrQ`,
	"dropdownCaret": `settings-menu_dropdownCaret_zYOmM`
};
export default ___CSS_LOADER_EXPORT___;
